<admin-header [primaryButtons]="headerPrimaryButtons" [secondaryButtons]="headerSecondaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<dx-data-grid id="grid" class="data-grid" [dataSource]="items" [remoteOperations]="false" [allowColumnReordering]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true" [showBorders]="true" (onExporting)="logExport()">
    <dxo-paging [pageSize]="100"></dxo-paging>
	<dxo-state-storing [enabled]="true" type="localStorage" storageKey="allocationsMain"></dxo-state-storing>
    <dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
    <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
	<dxo-export [enabled]="canExportGrid"></dxo-export>
	<dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
	<dxi-column type="buttons">
        <dxi-button hint="View" icon="fal fa-eye" [onClick]="viewRow"></dxi-button>
    </dxi-column>
    <dxi-column dataField="id" alignment="left" sortOrder="desc"></dxi-column>
	<dxi-column dataField="deliveryNoteId" caption="Delivery Note"></dxi-column>
	<dxi-column dataField="client.name" caption="Client"></dxi-column>
	<dxi-column dataField="clientLocation.name" caption="Location"></dxi-column>
	<dxi-column dataField="part.partNumber" caption="Part"></dxi-column>
	<dxi-column dataField="totalAssigned" caption="Total Quantity"></dxi-column>
	<dxi-column dataField="reportedBy.fullName" caption="Created By"></dxi-column>
	<dxi-column dataField="workOrderIds" caption="Work Orders" [visible]="false"></dxi-column>
	<dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
	<div *dxTemplate="let allocation of 'detail'">
	  <div class="master-detail-caption">{{
		"Work Orders for Allocation #" + allocation.data.id
	  }}</div>
	  <allocationGridDetails [allocationWorkOrders]="allocation.data.workOrders"></allocationGridDetails>
	</div>
</dx-data-grid>
<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#grid' }" [(visible)]="gridLoading" [showIndicator]="true" [showPane]="true" [shading]="true"></dx-load-panel>